/* eslint-disable quote-props */
import { css } from '@linaria/core';

export const classes = {
  grow: [
    css`flex-grow: 0 !important;`,
    css`flex-grow: 1 !important;`,
    css`flex-grow: 2 !important;`,
    css`flex-grow: 3 !important;`,
    css`flex-grow: 4 !important;`,
    css`flex-grow: 5 !important;`,
    css`flex-grow: 6 !important;`,
    css`flex-grow: 7 !important;`,
    css`flex-grow: 8 !important;`,
    css`flex-grow: 9 !important;`,
    css`flex-grow: 10 !important;`
  ],
  shrink: [
    css`flex-shrink: 0 !important;`,
    css`flex-shrink: 1 !important;`,
    css`flex-shrink: 2 !important;`,
    css`flex-shrink: 3 !important;`,
    css`flex-shrink: 4 !important;`,
    css`flex-shrink: 5 !important;`,
    css`flex-shrink: 6 !important;`,
    css`flex-shrink: 7 !important;`,
    css`flex-shrink: 8 !important;`,
    css`flex-shrink: 9 !important;`,
    css`flex-shrink: 10 !important;`
  ],
  flex: {
    'd-flex': css`display: flex !important;`,
    row: css`flex-direction: row !important`,
    column: css`flex-direction: column !important`,
    wrap: css`flex-wrap: wrap!important`
  },
  justify: {
    start: css`justify-content: flex-start !important;`,
    end: css`justify-content: flex-end !important;`,
    center: css`justify-content: center !important;`,
    between: css`justify-content: space-between !important;`,
    around: css`justify-content: space-around !important;`
  },
  align: {
    start: css`align-items: flex-start !important;`,
    end: css`align-items: flex-end !important;`,
    center: css`align-items: center !important;`,
    baseline: css`align-items: baseline !important;`,
    stretch: css`align-items: stretch !important;`
  }
};

export default (props = {}) => ({

  /* flexbox */
  [classes.flex['d-flex']]: true,
  [classes.flex.row]: props.row,
  [classes.flex.column]: props.column,
  [classes.flex.wrap]: props.wrap,

  /* grow and shrink */
  [classes.grow[props.grow]]: props.grow,
  [classes.shrink[props.shrink]]: props.shrink,

  /* justify-content */
  [classes.justify.start]: props.justifyStart || props.justify === 'start',
  [classes.justify.end]: props.justifyEnd || props.justify === 'end',
  [classes.justify.center]: props.justifyCenter || props.justify === 'center',
  [classes.justify.between]: props.justifyBetween || props.justify === 'between',
  [classes.justify.around]: props.justifyAround || props.justify === 'around',

  /* align-items */
  [classes.align.start]: props.alignStart || props.align === 'start',
  [classes.align.end]: props.alignEnd || props.align === 'end',
  [classes.align.center]: props.alignCenter || props.align === 'center',
  [classes.align.baseline]: props.alignBaseline || props.align === 'baseline',
  [classes.align.stretch]: props.alignStretch || props.align === 'stretch'

});
